import './Textarea.css'
const Textarea=(props)=>{
   
    return <textarea name="" id="" value={props.data} onChange={props.func}/>
}
export default Textarea;